module.exports = __webpack_public_path__ + "static/img/kr.3b2f0cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kr.jpg
// module id = S0ru
// module chunks = 15